
import './UrgencyWidget.css';
import bolt from '../../assets/images/bolt.png';
import React from "react";

function UrgencyWidget(props) {

    const taskUrgency = {
        1: <div className="boltRow"> <img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" ></img></div>,
        2: <div className="boltRow"> <img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /> <img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /></div>,
        3: <div className="boltRow"> <img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage"/> <img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /> <img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /></div>,
        4: <div className="boltRow"> <img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage"/> <img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /><img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /><img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /></div>,
        5: <div className="boltRow"> <img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage"/> <img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /><img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /><img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /><img src={bolt} alt="1 dimensional lightning bolt icon" className="boltImage" /></div>,
    }

    return (
        <div>
            {taskUrgency[props.taskUrgency]}
        </div>
    )
}

export default UrgencyWidget;